import updateAttachmentInOtherGroups from './common/update-attachment-in-other-groups'

function toggleAll() {
  const $this = $(this)
  const $exportAttachmentsInput = $this
    .closest('tr')
    .find('.export-attachment input')
  const $allRowsForGroup = $this.closest('table').find('tr.level_1')

  $allRowsForGroup.each(function () {
    const $exportAttachmentInput = $(this).find('.export-attachment input')
    const $exportAccountInput = $(this).find('.export-account-check input')
    $exportAttachmentInput.prop(
      'checked',
      $exportAttachmentsInput.prop('checked') &&
        $exportAccountInput.prop('checked')
    )

    updateAttachmentInOtherGroups($(this))
  })
}

export default () => {
  $(document).on(
    'change',
    '[data-behaviour="export-check-group-attachment"]',
    toggleAll
  )

  return () => {
    $(document).off(
      'change',
      '[data-behaviour="export-check-group-attachment"]',
      toggleAll
    )
  }
}
